import styled from 'styled-components';
import { Clickable } from 'src/components/clickable';
import { colorUtils, layout, remCalc } from 'src/components/base';

const baseMargin = 8;
export const minCardWidth = 160;

export const CategoryLogo = styled.img`
  height: 86px;
  width: 86px;
`;

export const BrandName = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
  line-height: 18px;
`;

export const BrandLogo = styled.img`
  max-height: 30px;
  width: 50px;
`;

export const CategoryName = styled.div`
  font-weight: 600;
  line-height: 18px;
`;

export const Card = styled(Clickable)`
  background: ${props => props.theme.bg.secondary};
  border-radius: ${layout.borderRadius};
  color: ${props => props.theme.text.primary};
  display: block;
  min-width: ${remCalc(minCardWidth)};
  padding: ${remCalc(baseMargin * 2)};
  padding-top: ${remCalc(baseMargin * 3)};
  position: relative;
  text-align: center;

  :hover,
  &.focus-visible {
    background-color: ${props =>
      colorUtils.shadeColor(props.theme.bg.secondary, -10)};
    outline: none;
  }

  ${BrandLogo} {
    position: absolute;
    right: ${remCalc(baseMargin * 2)};
    top: ${remCalc(baseMargin * 2)};
  }
`;
